/**
 * About section component - using original Portugal Portuguese text from old website
 */

import { Card } from '../ui/Card';
import aboutData from '@/data/about.json';
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';
import { motion } from 'framer-motion';

export function About() {
  const { ref, isIntersecting } = useIntersectionObserver({ threshold: 0.1 });

  return (
    <section id="about" ref={ref} className="section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isIntersecting ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="has-text-centered mb-6"
        >
          <h2 className="title is-2 has-text-weight-bold">
            {aboutData.title_parts.map((part, index) => (
              part.highlight ? (
                <span key={index} className="gradient-text">{part.text}</span>
              ) : (
                <span key={index}>{part.text}</span>
              )
            ))}
          </h2>
          <p className="subtitle is-5" style={{ maxWidth: '1000px', margin: '0 auto' }}>
            {aboutData.subtitle}
          </p>
        </motion.div>

        <div className="grid-3">
          {aboutData.cards.map((card, index) => (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 30 }}
              animate={isIntersecting ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <Card style={{ height: '100%', padding: '2rem', textAlign: 'center' }}>
                <div className="service-icon">
                  <i className={`fas ${card.icon}`}></i>
                </div>
                <h3 className="service-title">
                  {card.title}
                </h3>
                <p className="service-description">{card.description}</p>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
